export const deletingAccount = {
    english: 'Are you sure',
    italian: 'Puoi confermare',
    dutch: 'Ben je zeker',
    serbian: 'Zelis da obrises nalog',
    french: 'Es-tu sûr'
}

export const passwordChange = {
    english: 'type your new password',
    italian: 'la tua nuova password',
    dutch: 'uw nieuwe wachtwoord',
    serbian: 'unesi novu lozinku',
    french: 'votre nouveau mot de passe'
}

export const passwordSaved = {
    english: 'password saved',
    italian: 'password salvata',
    dutch: 'wachtwoord opgeslagen',
    serbian: 'lozinka sacuvana',
    french: 'mot de passe enregistré'
}

export const passwordLongerThan = {
    english: 'Must be longer than 8 characters',
    italian: 'Deve contenere più di 8 caratteri',
    dutch: 'Moet langer zijn dan 8 tekens',
    serbian: 'Sifra mora sadrzati vise od 8 karaktera',
    french: 'Doit contenir plus de 8 caractères'
}

export const passwordContainsLetters = {
    english: 'Must contain 1 lowercase and 1 capital letter',
    italian: 'Deve contenere 1 lettera minuscola e 1 lettera maiuscola',
    dutch: 'Moet 1 kleine letter en 1 hoofdletter bevatten',
    serbian: 'Mora sadrzati 1 veliko i 1 malo slovo',
    french: 'Doit contenir 1 minuscule et 1 majuscule lettre'
}

export const passwordSpecialCharacters = {
    english: 'Must contain at least 1 special character',
    italian: 'Deve contenere almeno 1 carattere speciale',
    dutch: 'Moet ten minste één speciaal teken bevatten',
    serbian: 'Mora sadrzati barem 1 specijalni karakter',
    french: 'Doit contenir au moins 1 caractère spécial'
}

export const passwordContainsNumber = {
    english: 'Must contain at least 1 number',
    italian: 'Deve contenere almeno 1 numero',
    dutch: 'Moet ten minste 1 cijfer bevatten ',
    serbian: 'Mora sadrzati barem jednu cifru',
    french: 'Doit contenir au moins 1 chiffre'
}

export  const salutation = {
    english: 'Hello',
    italian: 'Ciao',
    french: 'Salut',
    serbian: 'Zdravo',
    dutch: 'Hoi'
}

export const run = {
    english: 'Run',
    italian: 'Correre',
    french: 'Courir',
    serbian: 'Trčanje',
    dutch: 'Rennen'
}
export const walk = {
    english: 'Walk',
    italian: 'Camminare',
    french: 'Marcher',
    serbian: 'Hodanje',
    dutch: 'Lopen'
}

export const congrats = {
    english: 'You did it',
    italian: 'Congratulazioni',
    serbian: 'Čestitam',
    dutch: 'Goed gedaan',
    french: 'Bien joué'
}

export const required = {
    english: 'Required',
    italian: 'Campo Obbligatorio',
    dutch: 'Verplicht veld',
    serbian: 'Obavezno polje',
    french: 'Champs requis'
}

export const insertValidWeight = {
    english: 'insert valid weight in kgs',
    italian: 'inserisci il peso valido in kg',
    dutch: 'voer een geldig gewicht in kg in',
    serbian: 'unestite validnu tezinu u kg',
    french: 'insérez un poids valide en kg'
}

export const invalidEmail = {
    english: 'Invalid email',
    italian: 'e-mail non valido',
    dutch: 'Ongeldig e-mail',
    serbian: 'Email nije validan',
    french: 'Email invalide'
}

export const insertValidHeight = {
    english: 'insert valid height in cm',
    italian: 'inserisci altezza valida in cm',
    dutch: 'voer geldige hoogte in cm in',
    serbian: 'unesi validnu visinu u cm',
    french: 'insérez une hauteur valide en cm'
}

export const languageName = {
    english: 'english',
    italian: 'italian',
    dutch: 'dutch',
    serbian: 'serbian',
    french: 'french'
}

export const allowGeolocation = {
    english: 'please allow geolocation in order to see more data',
    italian: 'si prega di consentire la geolocalizzazione per vedere più dati',
    dutch: 'sta geolocatie toe om meer gegevens te zien',
    serbian: 'omoguci geolokaciju da bi vise podataka bilo prikazano',
    french: 'veuillez autoriser la géolocalisation afin de voir plus de données'
}